import React from 'react'
import { IUserDetails } from '../../../interfaces/user.interface'
import { ICourse, ICourseLessonContent } from '../../../interfaces/ICourse'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import { ISchool } from '../../../interfaces/school.interface'
import PageDescriptionComponent from '../../HelpfulGuides/PageDescriptionComponent'
import BaseBreadcrumbComponent from '../../Breadcrumbs/BaseBreadcrumpComponent'
import { List, Paper, Typography } from '@mui/material'
import CurrencyCodeComponent from '../../CurrencyComponents/CurrencyCodeComponent'
import LessonExpansionComponent from '../../Classroom/ClassroomLearnersComponents/SchoolCourseDetails/LessonExpansionComponent'
import CourseDetailsActionComponent from './CourseDetailsActionComponent'
import MyViewEditorHtml from '../../MyEditor/MyViewEditorHtml'
import CourseDetailsActionComponentMedia from './CourseDetailsActionComponentMedia'
import { formatAmount } from '../../../services/utils'
import CourseDetailsOtherCoursesComponent from './CourseDetailsOtherCoursesComponent'

interface ICourseInfo {
  schoolDetailsFromCourse: ISchool
  courseDetails: ICourse
  courseLessonContent: Array<ICourseLessonContent>
  paymentPlans: IPaymentsPlan[]
  userDetails: IUserDetails | undefined
}

const CourseDetailsComponentSmall = (props: ICourseInfo) => {
  return (
    <div
      style={{
        backgroundColor: '#fafafa',
      }}
    >
      <div
        style={{
          width: '100%',
          padding: '20px',
          paddingBottom: '10px',
          backgroundColor: 'inherit',
        }}
      >
        <PageDescriptionComponent
          padding={'0px'}
          style={{ backgroundColor: 'inherit' }}
          textContent={
            <BaseBreadcrumbComponent
              items={[
                { path: '/', title: 'Home' },
                {
                  path: `/course-details/${
                    props.courseDetails.slug || props.courseDetails._id
                  }`,
                  title: props.courseDetails.name,
                  isActive: true,
                },
              ]}
            />
          }
        />

        <Typography
          gutterBottom={true}
          variant="h4"
          style={{
            wordBreak: 'break-word',
          }}
        >
          <b> {props.courseDetails.name} </b>
        </Typography>
        <Typography variant="body2">
          course code: {props.courseDetails.course_code}
        </Typography>
        <Typography>{props.courseDetails.short_description}</Typography>
        <List
          disablePadding={true}
          style={{ padding: '20px 0px' }}
          dense={true}
        >
          {props.courseDetails && Boolean(props.courseDetails.price) && (
            <div style={{ padding: '20px 0px' }}>
              <Typography variant={'h5'}>
                <CurrencyCodeComponent school={props.schoolDetailsFromCourse} />
                <b>{' ' + formatAmount(props.courseDetails.price)}</b>
              </Typography>
            </div>
          )}
        </List>

        {/*<div>*/}
        {/*  <CourseDetailsClusterList*/}
        {/*    school={props.schoolDetails}*/}
        {/*    paymentPlans={props.paymentPlans}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
      <div style={{ padding: '0px 20px' }}>
        <CourseDetailsActionComponentMedia
          courseDetails={props.courseDetails}
        />
      </div>
      <div style={{ padding: '20px' }}>
        <CourseDetailsActionComponent
          courseDetails={props.courseDetails}
          schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          userDetails={props.userDetails}
          paymentPlans={props.paymentPlans}
          courseLessonContent={props.courseLessonContent}
          hideActionButton={true}
        />
      </div>

      <div
        style={{
          position: 'fixed',
          bottom: '-2px',
          // background: '#212330',
          background: '#fff',
          padding: '10px',
          width: '100%',
          zIndex: 1,
          borderRadius: '10px 10px 0px 0px',
          boxShadow:
            '0 -2px 2px -2px rgba(34,47,62,.1), 0 -8px 8px -4px rgba(34,47,62,.07)',
        }}
      >
        <CourseDetailsActionComponent
          courseDetails={props.courseDetails}
          schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          userDetails={props.userDetails}
          paymentPlans={props.paymentPlans}
          courseLessonContent={props.courseLessonContent}
          mini={true}
        />
      </div>
      <div
        style={{
          width: '100%',
          maxWidth: '700px',
          padding: '20px',
        }}
      >
        <MyViewEditorHtml notes={props.courseDetails.description} />
      </div>
      <div>
        <div style={{ padding: '10px' }}>
          <Typography
            gutterBottom={true}
            variant={'h6'}
            style={{
              marginLeft: '10px',
            }}
          >
            <b> Course outline</b>
          </Typography>
          <Paper
            style={{
              border: 'none',
            }}
            variant={'outlined'}
          >
            <LessonExpansionComponent
              courseDetails={props.courseDetails}
              courseLessonContents={props.courseLessonContent}
            />
          </Paper>
        </div>
      </div>
      {Boolean(props.courseDetails.requirements) && (
        <div style={{ padding: '20px', width: '100%' }}>
          <Typography gutterBottom={true} variant={'h6'}>
            <b>Course requirements</b>
          </Typography>
          <Typography>
            {props.courseDetails.requirements ||
              'There are no requirements for you to take this course'}
          </Typography>
        </div>
      )}
      {Boolean(props.courseDetails.tutorDescription) && (
        <div style={{ padding: '20px', width: '100%', marginTop: '30px' }}>
          <Typography gutterBottom={true} variant={'h6'}>
            <b>About the tutor</b>
          </Typography>
          <Typography>{props.courseDetails.tutorDescription}</Typography>
        </div>
      )}

      <div style={{ height: '100px' }} />
      {!props.courseDetails?.hide_related_courses &&
        !props.schoolDetailsFromCourse?.limit_discovery_to_faculties && (
          <>
            <CourseDetailsOtherCoursesComponent
              schoolDetailsFromCourse={props.schoolDetailsFromCourse}
              currentCourseId={props.courseDetails?._id}
            />
            <div style={{ height: '50px' }} />
          </>
        )}
    </div>
  )
}

export default CourseDetailsComponentSmall
